import { render, staticRenderFns } from "./GenericLodgingsDisplay.vue?vue&type=template&id=0e222982&scoped=true&"
import script from "./GenericLodgingsDisplay.vue?vue&type=script&lang=js&"
export * from "./GenericLodgingsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./GenericLodgingsDisplay.vue?vue&type=style&index=0&id=0e222982&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e222982",
  null
  
)

export default component.exports